/**
 * Auth Module
 */
import Vue from "vue";
import Nprogress from "nprogress";
import router from "../../../router";
import api from "../../../api";
import { store } from "../../store";
const state = {
	token: localStorage.getItem("token"),
	role: localStorage.getItem("role"),
	username: localStorage.getItem("username"),
	name: localStorage.getItem("name"),
	user_id: localStorage.getItem("user_id")
};

// getters
const getters = {
	getToken: state => {
		return state.token;
	},
	getUserRole: state => {
		return state.role;
	}
};

// actions
const actions = {
	signIn(context, payload) {
		context.commit("loginUser");
		return api
			.userLogin(payload.username, payload.password)
			.then(res => {
				Nprogress.done();
				if (res.status === 200)
					return context.commit("loginUserSuccess", {...res.data, is_remember_user : payload.is_remember_user});
				else return context.commit("loginUserFailure");
			})
			.catch(error => {
				console.log("catch", error);
				context.commit("loginUserFailure");
				return false;
			});
	},
	logoutUser(context) {
		Nprogress.start();
		context.commit("logoutUser");
	},
	async refreshToken(context) {
		Nprogress.start();
		const data = await api.refreshToken({
			token: context.state.token
		});
		if (data.status == 200) {
			localStorage.setItem("last_login", new Date());
			context.commit("updateToken", { token: data.data.token });
			context.dispatch("getAppData");
		} else {
			swal.fire(
				"Thông báo",
				"Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại",
				"info"
			);
			context.dispatch("logoutUser");
		}
		Nprogress.done();
		return true;
	}
};

// mutations
const mutations = {
	loginUser(state) {
		Nprogress.start();
	},
	loginUserSuccess(state, data) {
		// token
		state.token = data.token;
		localStorage.setItem("token", data.token);

		// role
		state.role = data.role;
		localStorage.setItem("role", data.role);

		// username
		state.username = data.username;
		localStorage.setItem("username", state.username);

		// user_id
		state.user_id = data.user_id;
		localStorage.setItem("user_id", state.user_id);

		// name
		state.name = data.name;
		localStorage.setItem("name", state.name);

		// last_login
		localStorage.setItem("is_remember_user", data.is_remember_user);
		localStorage.setItem("last_login", new Date());

		router.push("/dashboard");
		store.dispatch("getAppData");
		setTimeout(function() {
			Vue.notify({
				group: "loggedIn",
				type: "success",
				text: "Đăng nhập thành công!"
			});
		}, 1500);
	},
	loginUserFailure(state, error) {
		Nprogress.done();
		swal.fire(
			"Lỗi",
			"Vui lòng kiểm tra lại tên đăng nhập hoặc mật khẩu",
			"error"
		);
		// Vue.notify({
		// 	group: "loggedIn",
		// 	type: "error",
		// 	text: error.message
		// });
	},
	logoutUser(state) {
		state.token = null;
		localStorage.removeItem("token");
		state.role = null;
		localStorage.removeItem("role");
		router.push("/login");
	},
	updateToken(state, data) {
		state.token = data.token;
		localStorage.setItem("token", data.token);
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
